var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "spinner spinner--wave", style: _vm.styles },
    [_c("div"), _vm._v(" "), _c("div"), _vm._v(" "), _c("div")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }